import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import { Form, Field, CellGroup,Button,Uploader,DatePicker,Popup,List,Cell,Divider,PullRefresh,Tab, Tabs } from 'vant';
import 'vant/lib/index.css';
import i18n from "@/i18n";

const app = createApp(App)

app.use(store)
  .use(router)
  .use(i18n)
  .use(ViewUIPlus)
  .use(Form)
  .use(Field)
  .use(CellGroup)
  .use(Button)
  .use(Uploader)
  .use(DatePicker)
  .use(Popup)
  .use(List)
  .use(Divider)
  .use(PullRefresh)
  .use(Cell)
  .use(Tab)
  .use(Tabs)
  .mount('#app')



